import initQrPopup from 'components/qr-popup'
import { initForm } from 'landings/__assets__/scripts/components/form-handling'
import initExitPopup from 'landings/__assets__/scripts/components/exit-popup'

initQrPopup()
initForm()
initExitPopup()
